import React from "react";

const File = props => (
  <svg viewBox="0 0 16 20" width="1em" height="1em" {...props}>
    <path
      d="M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

export default File;




// WEBPACK FOOTER //
// src/resources/svg/File.js